import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/shared/Header/Header";
import LandingPage from "./pages/LandingPage";
import MalligyongTracker from "./pages/MalligyongTracker";
import NuriTracker from "./pages/NuriTracker";
import NTUSatTracker from "./pages/NTUSatTracker";
import KDICSatTracker from "./pages/KDICSatTracker";
import MalaySatTracker from "./pages/MalaySatTracker";
import PageNotFound from "./pages/PageNotFound";
import useIsMobile from "./hooks/useIsMobile";
import MobileLandingPage from "./pages/MobileLandingPage";
import dayjs from "./utils/dayjs";
import LoginPage from "./pages/login";
import SignUpPage from "./pages/signup";
import MyOOSIPage from "./pages/my-oosi";

function App() {
  const isMobile = useIsMobile();
  return (
    <>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route
            path="/"
            element={isMobile ? <MobileLandingPage /> : <LandingPage />}
          />
          <Route path="/malligyong-tracker" element={<MalligyongTracker />} />
          <Route path="/nurisat-tracker" element={<NuriTracker />} />
          <Route path="/ntu-sat-tracker" element={<NTUSatTracker />} />
          <Route path="/kdic-stm" element={<KDICSatTracker />} />
          <Route path="/malay-sat-tracker" element={<MalaySatTracker />} />
          <Route path="/my-oosi" element={<MyOOSIPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
